import React from "react"
import { StaticImage } from "gatsby-plugin-image"

export default function AppStoreButton() {
  return (
    <a href="https://apps.apple.com/us/app/hit-your-steps/id1590501792">
        <StaticImage src="../images/download-on-the-app-store.png" placeholder="blurred" alt="Download on the App Store" width={200}/>
    </a>
  )
}